import React from 'react';
import Maintenance from '../../../assets/images/Maintenance.png';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

const MaintainanceNotification = ({ message }) => {
  const [open, setOpen] = React.useState(true);
  return (
    open &&
    message && (
      <div className="maintenance-card d-flex align-items-center mb-4 overflow-hidden position-relative flex-column flex-sm-row">
        <img src={Maintenance} className="flex-shrink-0 me-4" alt="Maintenance" />
        <div className="ml-2 w-75" dangerouslySetInnerHTML={{ __html: message }}></div>
        <div className="close-btn position-absolute top-0 end-0 m-4">
          <FontAwesomeIcon onClick={() => setOpen(!open)} size="5px" icon={faXmark} />
        </div>
      </div>
    )
  );
};

MaintainanceNotification.propTypes = {
  message: PropTypes.string
};

export default MaintainanceNotification;
